import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { IconCircleFilled, IconX } from "@tabler/icons-react";
import { useState } from "react";
import { Input } from "./Input";
import { useFormik } from "formik";
import moment from "moment";

const StudentGraduationRegister = ({
  fights,
  open,
  onClose,
  handleMutate,
}: {
  fights: any;
  open: boolean;
  onClose: () => void;
  handleMutate: ({
    graduationId,
    fightId,
    frequency,
    monthsInGradution,
    graduationDate,
  }: {
    graduationId: string;
    fightId: string;
    frequency: number;
    monthsInGradution: number;
    graduationDate?: Date;
  }) => void;
}) => {
  const [fightId, setFightId] = useState("");
  const [graduationId, setGraduationId] = useState("");

  const { values, handleChange, handleSubmit } = useFormik({
    initialValues: {
      fightId: "",
      graduationId: "",
      frequency: "",
      monthsInGradution: "",
      graduationDate: moment().format("YYYY-MM-DD").toString(),
    },
    onSubmit: (values) => {
      handleMutate({
        ...values,
        graduationId,
        fightId,
        frequency: Number(values.frequency || 0),
        monthsInGradution: Number(values.fightId || 0),
        graduationDate: moment(values.graduationDate).toDate(),
      });
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      {/* <Loading loading={isLoadingFights || isFetchingFights || isPending} /> */}
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Graduar aluno
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            <Typography sx={{ fontWeight: 700, fontSize: 12 }}>
              Modalidade
            </Typography>
            <Select
              sx={{ marginTop: 1 }}
              id="fightId"
              value={fightId}
              fullWidth
              // onChange={handleChange}
            >
              {fights?.map((item: any) => (
                <MenuItem
                  key={item?.id}
                  value={item?.id}
                  onClick={() => setFightId(item?.id)}
                >
                  {item?.name}
                </MenuItem>
              ))}
            </Select>
          </Grid2>
          {fightId && (
            <>
              <Grid2 size={12}>
                <Typography sx={{ fontWeight: 700, fontSize: 12 }}>
                  Graduação
                </Typography>
                <Select
                  sx={{ marginTop: 1 }}
                  id="fightId"
                  value={graduationId}
                  fullWidth
                  // onChange={handleChange}
                >
                  {fights
                    ?.filter((f: any) => Number(f?.id) === Number(fightId))
                    ?.map((f: any) => {
                      return f.graduations.map((g: any) => (
                        <MenuItem
                          key={g.id}
                          value={g.id}
                          onClick={() => setGraduationId(g.id)}
                        >
                          <Stack
                            sx={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <IconCircleFilled color={g?.color} />
                            <Typography>{g?.belt}</Typography>
                          </Stack>
                        </MenuItem>
                      ));
                    })}
                </Select>
              </Grid2>
              <Grid2 size={12}>
                <Input
                  id="frequency"
                  name="frequency"
                  label="Aulas participadas"
                  placeholder="Aulas participadas"
                  type="text"
                  fullWidth
                  size="small"
                  value={values.frequency}
                  onChange={handleChange}
                />
              </Grid2>
              {/* <Grid2 size={12}>
                <Input
                  id="monthsInGradution"
                  name="monthsInGradution"
                  label="Tempo (em meses)"
                  placeholder="Meses"
                  type="text"
                  fullWidth
                  size="small"
                  value={values.monthsInGradution}
                  onChange={handleChange}
                />
              </Grid2> */}
              <Grid2 size={12}>
                <Input
                  id="graduationDate"
                  name="graduationDate"
                  label="Data graduação"
                  type="date"
                  fullWidth
                  value={values.graduationDate}
                  onChange={handleChange}
                  onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                    e.target.showPicker()
                  }
                />
              </Grid2>
              <Grid2 size={12}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={() => handleSubmit()}
                >
                  Graduar aluno
                </Button>
              </Grid2>
            </>
          )}
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default StudentGraduationRegister;
